import { render, staticRenderFns } from "./ReportePorTipoActivo.vue?vue&type=template&id=3412f8d0"
import script from "./ReportePorTipoActivo.vue?vue&type=script&lang=js"
export * from "./ReportePorTipoActivo.vue?vue&type=script&lang=js"
import style0 from "../main.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports